<template>
  <div>
    <f7-row>
      <f7-col width="100">
        <DxDataGrid
          id="optimalDistributionAdvanced_results"
          :data-source="resultsFormated"
          :column-min-width="70"
          :column-auto-width="true"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="true"
          :show-row-lines="true"
          style="margin-top: 5px;"
          :row-alternation-enabled="true"
          @exporting="onExporting"
        >
          <DxHeaderFilter :visible="true" />
          <DxStateStoring
            :enabled="true"
            type="localStorage"
            storage-key="DxOptimalCropDistributionAdvanced"
          />
          <DxExport
            :enabled="true"
          />
          <DxPaging :page-size="10" />
          <DxSearchPanel
            :visible="false"
          />
          <DxColumn :caption="$t('DxOptimalCropDistributionAdvanced_Results_Column_Caption')">
            <DxColumn
              :data-field="'year'"
              :name="'year'"
              :caption="$t('year')"
              :allow-header-filtering="true"
            />
            <DxColumn
              v-for="year in years"
              :key="year"
              :data-field="year"
              :name="year"
              :allow-header-filtering="false"
            />
            <DxColumn
              :data-field="'average'"
              :name="'average'"
              :caption="$t('average')"
              :allow-header-filtering="false"
            />
            <DxColumn
              :data-field="'standardDeviation'"
              :name="'standardDeviation'"
              :caption="$t('standardDeviation')"
              :allow-header-filtering="false"
            />
          </DxColumn>
        </DxDataGrid>
      </f7-col>
      <f7-col
        v-for="year in years"
        :key="year"
        width="33"
      >
        <DxDataGrid
          :id="`optimalDistributionAdvanced_${year}`"
          :data-source="optimizationsFormated[year]"
          :column-min-width="70"
          :column-auto-width="true"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="true"
          :show-row-lines="true"
          style="margin-top: 5px;"
          :row-alternation-enabled="true"
        >
          <DxHeaderFilter :visible="true" />
          <DxStateStoring
            :enabled="true"
            type="localStorage"
            storage-key="DxOptimalCropDistributionAdvanced"
          />
          <DxPaging :page-size="10" />
          <DxSearchPanel
            :visible="false"
          />
          <DxColumn :caption="`${$t('DxOptimalCropDistributionAdvanced_Column_Caption')} ${year}`">
            <DxColumn
              :data-field="'crop'"
              :name="'crop'"
              :caption="$t('Crop')"
              :allow-header-filtering="true"
            />
            <DxColumn
              :data-field="'surface'"
              :name="'surface'"
              :caption="$t('DxOptimalCropDistributionAdvanced_Column_surface')"
              :allow-header-filtering="false"
            />
            <DxColumn
              :data-field="'totalIrrigation'"
              :name="'totalIrrigation'"
              :caption="$t('DxOptimalCropDistributionAdvanced_Column_totalIrrigation')"
              :allow-header-filtering="false"
            />
            <DxColumn
              data-field="irrigationDose"
              name="irrigationDose"
              :caption="$t('DxOptimalCropDistributionAdvanced_Column_irrigationDose')"
              :allow-header-filtering="false"
              alignment="right"
              :calculate-display-value="calculateIrrigationDose"
            />
          </DxColumn>
        </DxDataGrid>
      </f7-col>
    </f7-row>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxPaging,
  DxSearchPanel,
  DxExport,
  DxColumn,
  DxStateStoring,
  DxHeaderFilter,
} from 'devextreme-vue/data-grid';

export default {
  name: 'DxOptimalCropDistributionAdvanced',
  components: {
    DxDataGrid,
    DxPaging,
    DxSearchPanel,
    DxExport,
    DxColumn,
    DxStateStoring,
    DxHeaderFilter,
  },
  props: {
    results: {
      type: Object,
      default: () => {},
    },
    optimizations: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      optimizationsFormated: {},
      resultsFormated: [],
    };
  },
  computed: {
    years() {
      return Object.keys(this.optimizations);
    },
  },
  beforeMount() {
    this.setOptimizationsFormated();
    this.setResultsFormated();
  },
  methods: {
    onExporting(e) {
      this.$helpers.onExporting(e, 'optimizations', 'optimalDistributions.xlsx');
    },
    setResultsFormated() {
      const resultsFormated = [];
      for (const year in this.results) {
        if (Object.hasOwnProperty.call(this.results, year)) {
          const result = this.results[year];
          const resultFormated = {};
          resultFormated.year = year;
          for (let i = 0; i < this.years.length; i += 1) {
            resultFormated[this.years[i]] = result[i];
          }
          resultFormated.average = result[this.years.length];
          resultFormated.standardDeviation = `±${result[this.years.length + 1]}`;
          resultsFormated.push(resultFormated);
        }
      }
      this.resultsFormated = resultsFormated;
    },
    setOptimizationsFormated() {
      const optimizationsFormated = {};
      for (const year in this.optimizations) {
        if (Object.hasOwnProperty.call(this.optimizations, year)) {
          optimizationsFormated[year] = {};
          const optimization = this.optimizations[year];
          const optimizationsYear = [];
          for (const crop in optimization) {
            if (Object.hasOwnProperty.call(optimization, crop)) {
              const cropData = optimization[crop];
              let cropName = crop;
              if (cropName === 'fallow') {
                cropName = 'Barbecho';
              }
              optimizationsYear.push({
                surface: cropData.surface,
                totalIrrigation: cropData.totalIrrigation,
                crop: cropName,
              });
            }
          }
          optimizationsFormated[year] = optimizationsYear;
        }
      }
      this.optimizationsFormated = optimizationsFormated;
    },
    calculateIrrigationDose(rowData) {
      if (rowData.surface) {
        return (rowData.totalIrrigation / rowData.surface).toFixed(2);
      }
      return 0;
    },
  },
};
</script>

<style scoped>
</style>
